// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2Tjgv","item":"PaymentsMobile_item__2T2Ng","label":"PaymentsMobile_label__1gAB3","amount":"PaymentsMobile_amount__1pm5Y"};